var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_bubble",
    "data-name": "vuesax/bold/bubble",
    transform: "translate(-172 -636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bubble"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(172 636)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(172 636)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M5.38,0a5.38,5.38,0,1,0,5.38,5.38A5.382,5.382,0,0,0,5.38,0Z",
    transform: "translate(182.21 637.75)",
    fill: "#355376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M3.33,0A3.33,3.33,0,1,0,6.66,3.33,3.335,3.335,0,0,0,3.33,0Z",
    transform: "translate(175.03 649.03)",
    fill: "#355376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M2.81,0A2.81,2.81,0,1,0,5.62,2.81,2.812,2.812,0,0,0,2.81,0Z",
    transform: "translate(185.81 652.62)",
    fill: "#355376"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueDots);
export default __webpack_public_path__ + "static/media/blue-dots.425589184c3a13ee951469fd652205fb.svg";
export { ForwardRef as ReactComponent };